package com.milta.core.localization.translations.sq

import com.milta.core.localization.SettingsStrings

internal val Settings = SettingsStrings(
    profileSectionTitle = "PROFILI I ORGANIZATËS",
    profileNameLabel = "Emri i organizatës",
    languageSectionTitle = "GJUHA E NDËRFAQES",
    languageSearchPlaceholder = "Kërko një gjuhë...",
    languageMoreAvailable = "%d gjuhë të tjera në dispozicion",
    languageErrorGeneric = "Ndodhi një gabim. Ju lutemi provoni përsëri.",
    subscriptionSectionTitle = "ABONIMI",
    subscriptionPlanLabel = "Plani",
    subscriptionBillingLabel = "Faturimi",
    subscriptionRenewalLabel = "Rinovimi i ardhshëm",
    subscriptionBillingMonthly = "Mujor",
    subscriptionBillingAnnual = "Vjetor",
    subscriptionPlanOrganisationLabel = "Organizatë (Menaxher + ekip)",
    subscriptionPriceSuffix = "pa TVSH / muaj",
    subscriptionUnavailable = "I padisponueshëm",
    deleteSectionTitle = "Fshi organizatën",
    deleteWarning = "Ky veprim është i përhershëm dhe i pakthyeshëm.",
    deleteDescription = "Itineraret dhe dëshmitë e dorëzimit do të fshihen. Llogaritë e shoferëve do të shkëputen nga organizata, por nuk do të fshihen kurrë.",
    deleteConfirmLabel = "Për të konfirmuar, shkruani emrin e organizatës",
    deleteButton = "Fshi përgjithmonë",
    deleteFinalDialogTitle = "Konfirmoni fshirjen e përhershme?",
    deleteFinalDialogMessage = "Ky veprim nuk mund të zhbëhet. Organizata, itineraret dhe dëshmitë e dorëzimit të saj do të fshihen përgjithmonë.",
    deleteErrorGeneric = "Ndodhi një gabim. Ju lutemi provoni përsëri.",
    legalSectionTitle = "INFORMACION LIGJOR",
    legalTermsLabel = "Kushtet e përdorimit",
    legalPrivacyLabel = "Privatësia & GDPR",
)
